export const baseEndpoint = "/v1/users";

export const userConfigs = {
  createUser: {
    method: "POST",
    endpoint: `${baseEndpoint}/sign-up`,
  },
  createSession: {
    method: "POST",
    endpoint: `${baseEndpoint}/sign-in`,
  },
  deleteSession: {
    method: "POST",
    endpoint: `${baseEndpoint}/sign-out`,
  },
  getCurrentUserInfo: {
    method: "GET",
    endpoint: `${baseEndpoint}/me`,
  },
  updateCurrentUserInfo: {
    method: "POST",
    endpoint: `${baseEndpoint}/me`,
  },
  updatePassword: {
    method: "POST",
    endpoint: `${baseEndpoint}/password`,
  },
  requestPasswordReset: {
    method: "POST",
    endpoint: `${baseEndpoint}/password/reset/link`,
  },
  resetPassword: {
    method: "POST",
    endpoint: `${baseEndpoint}/password/reset`,
  },
  emailVerification: {
    method: "POST",
    endpoint: `${baseEndpoint}/verify-email/$token`,
  },
};
